import { render, staticRenderFns } from "./proposal-40-agreement.vue?vue&type=template&id=7dc2b199"
import script from "./proposal-40-agreement.vue?vue&type=script&lang=js"
export * from "./proposal-40-agreement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports